enum CardTypeEnum {
    SimpleText = "SimpleText",
    SimpleTextPhoto = "SimpleTextPhoto",
    SolidColor = "SolidColor",
    SolidColorPhoto = "SolidColorPhoto",
}

export default CardTypeEnum;